<template>
  <div>
    <b-container>
      <br />
      <b-jumbotron header="Stundensatz-Rechnerin" lead="zum Berechnen transparenter und fairer Stundensätze von Selbsständigen" bg-variant="dark" text-variant="white">
        <p>Für weitere Hintergrundinformationen und wie du dieses Tool selbst aufsetzen kannst, besuche das GitLab Repository dieses Projekts.</p>
        <b-btn variant="success" href="#">@ gitlab.com</b-btn>
      </b-jumbotron>
      <p>
        <b-row>
          <b-col sm="8" md="7">Wochenstunden die gearbeitet werden sollen:</b-col>
          <b-col sm="3" md="2"><b-form-input v-model="wochenstunden" type="number"></b-form-input></b-col>
          <b-col sm="1" md="3">h</b-col>
        </b-row>
        <b-row>
          <b-col sm="8" md="7">Nettolohn der pro Monat übrig bleiben soll:</b-col>
          <b-col sm="3" md="2"><b-form-input v-model="monatsnettolohn" type="number"></b-form-input></b-col>
          <b-col sm="1" md="3">€</b-col>
        </b-row>
        <br>
        <b-row>
          <b-col sm="5" md="4">Das ergibt einen Nettostundenlohn von:</b-col>
          <b-col sm="4" md="3">{{ monatsnettolohn }} EUR / ({{ wochenstunden }}h * 4.33 Wochen) =</b-col>
          <b-col sm="3" md="5"><b>{{ nettosatz.toFixed(2) }} €/h</b></b-col>
        </b-row>
      </p>
      <p>
        Nun müssen zuerst einmal die Sozialversicherungsabgaben und die Lohnsteuer
        aufgerechnet werden, wobei wir die passende Steuerklasse anhand des Jahresbruttolohns
        wählen müssen, der bei 12 Monaten (hier sind keine Urlaubsgelder eingereichnet) mit
        unserem Nettolohn <i>{{ jahresbrutto.toFixed(2) }} €</i> beträgt.
      </p>
      <p>
        <b-row>
          <b-col cols="7">Sozialversicherung:</b-col>
          <b-col cols="2"><b-form-input v-model="sv" type="number"></b-form-input></b-col>
          <b-col cols="3">%</b-col>
        </b-row>
        <b-row>
          <b-col cols="7">Effektiver Lohn-/Einkommenssteuersatz:</b-col>
          <b-col cols="2"><b-form-input v-model="steuer" type="number"></b-form-input></b-col>
          <b-col cols="3">%</b-col>
        </b-row>
        <br>
        <b-row>
          <b-col cols="7">Das ergibt einen Bruttostundensatz von:</b-col>
          <b-col cols="5"><b>{{ bruttosatz.toFixed(2) }} €/h</b></b-col>
        </b-row>
      </p>
      <hr>
      <p>
        Für jede produktiv aufgewandte Stunde, die auch verrechnet werden kann, wird üblicherweise zusätzliche Zeit
        für Vor- und Nachbereitung, Dokumentation, Planung, Recherche etc. benötigt. All dies fassen wir
        hier unter dem Label <i>Vor- &amp; Nachbereitungszeit</i> zusammen &mdash; also der Anzahl an Stunden die pro
        produktiv verrechneter Stunde zusätzlich benötigt werden, um die Leistung zu erbringen.
      </p>
      <p>
        <b-row>
          <b-col cols="7">Vor- &amp; Nachbereitungszeit pro produktiver Stunde:</b-col>
          <b-col cols="2"><b-form-input v-model="reprostunden" type="number"></b-form-input></b-col>
          <b-col cols="3">h</b-col>
        </b-row>
        <br>
        <b-row>
          <b-col cols="7">Das ergibt einen reinen Stundensatz der produktiven Arbeitskraft von:</b-col>
          <b-col cols="5"><b>{{ stundensatzMitReprostunden.toFixed(2) }} €/h</b></b-col>
        </b-row>
      </p>
      <hr>
      <p>
        <b-row>
          <b-col cols="7">Arbeitstage im Jahr:</b-col>
          <b-col cols="2"><b-form-input v-model="arbeitstage" type="number"></b-form-input></b-col>
          <b-col cols="3">Tage</b-col>
        </b-row>
        <b-row>
          <b-col cols="7">Davon Urlaubstage:</b-col>
          <b-col cols="2"><b-form-input v-model="urlaubstage" type="number"></b-form-input></b-col>
          <b-col cols="3">Tage</b-col>
        </b-row>
        <b-row>
          <b-col cols="7">Durchschnittliche Krankenstandstage im Jahr:</b-col>
          <b-col cols="2"><b-form-input v-model="krankenstandstage" type="number"></b-form-input></b-col>
          <b-col cols="3">Tage</b-col>
        </b-row>
        <b-row>
          <b-col cols="7">Durchschnittliche Pflege-, Siedel- und andere arbeitsfreie Tage im Jahr:</b-col>
          <b-col cols="2"><b-form-input v-model="pflegetage" type="number"></b-form-input></b-col>
          <b-col cols="3">Tage</b-col>
        </b-row>
      </p>
      <p>
        Von {{ arbeitstage }} Arbeitstagen im Jahr sind also nur {{ arbeitstageNetto }} Tage
        wirklich für die Arbeit verfügbar, das entspricht {{ arbeitstageNettoProzent.toFixed(2) }} %. Wir
        müssen also die tatsächlich verfügbaren Tage als Ausgangsbasis (100%) nehmen und
        auf die auszubezahlenden Arbeitstage aufrechnen (entspricht + {{ arbeitstageBruttoProzent.toFixed(2) }} %).
      </p>
      <p> Ingesamt können wir also von den {{ wochenstunden }} nominell zur Verfügung stehenden Stunden
        nur {{ nettostunden.toFixed(2) }} Stunden in der Woche bzw. {{ (nettostunden * 4.33).toFixed(2) }}
        Stunden im Monat als produktive Leistungsstunden verrechnen.
      </p>
      <p>
        <b-row>
          <b-col cols="7">Das ergibt einen Brutto-Stundensatz der produktiven Arbeitsstunde von:</b-col>
          <b-col cols="5"><b>{{ stundensatzProduktiv.toFixed(2) }} €/h</b></b-col>
        </b-row>
      </p>
      <hr>
      <p>Das ist also der Stundensatz, den wir verrechnen müssten, wenn wir von einer 100%igen Auslastung
        über das ganze Jahr ausgehen könnten, und wenn es da nicht noch so Dinge gebe wie einen Arbeitsplatz
        und ein Büro, eine Verwaltung und Leute die sich um die ganze nötige Bürokratie kümmern, sowie bei
        Projekten, die eine einzelne Person übersteigen auch Leute, die die nötigen Koordinationsarbeit,
        Projektleitung, etc. übernehmen.
      </p>
      <p>Ein Kostenfaktor, der für jede Person im Betrieb entsteht, sind die Kosten für einen Arbeitsplatz.
        Da ist es klarerweise schwer, etwas so pauschal für alle gleich anzugeben. Wir verwenden hier aber eine
        durchschnittliche Summe, die für einen Arbeitsplatz im Monat verwendet wird. Hier können auch
        anteilig bereits Kosten für Meetingräume etc. eingerechnet werden, dafür eignet sich in den meisten
        Fällen aber besser der Faktor für die restlichen Betriebskosten weiter unten.
      </p>
      <p>
        <b-row>
          <b-col cols="7">Durchschnittliche Kosten für einen Arbeitsplatz:</b-col>
          <b-col cols="2"><b-form-input v-model="arbeitsplatz" type="number"></b-form-input></b-col>
          <b-col cols="3">€ monatlich</b-col>
        </b-row>
        <b-row>
          <b-col cols="7">&nbsp;</b-col>
          <b-col cols="5"><small><i>Entspricht einem +{{ arbeitsplatzProzent.toFixed(2) }}% Faktor vom produktiven Brutto-Stundensatz</i></small></b-col>
        </b-row>
        <b-row>
          <b-col cols="7">Damit steigt der Stundensatz auf :</b-col>
          <b-col cols="5"><b>{{ (stundensatzProduktiv * (100 + arbeitsplatzProzent) / 100).toFixed(2) }} €/h</b></b-col>
        </b-row>
      </p>
      <p>Außerdem müssen wir für uns bzw. jede*n Mitarbeiter*in auch ein Budget für Weiterbildungskosten
        einplanen, da wir ja auch in vielen Jahren noch auf dem neuesten Stand sein und innovative Produkte
        und Dienstleistungen liefern wollen. In diesen Kostenfaktor fallen unter anderem Kosten für Kursen,
        Workshops, Schulungen und Konferenzbesuche.
      </p>
      <p>
        <b-row>
          <b-col cols="7">Durchschnittliche Weiterbildungskosten:</b-col>
          <b-col cols="2"><b-form-input v-model="weiterbildung" type="number"></b-form-input></b-col>
          <b-col cols="3">€ monatlich</b-col>
        </b-row>
        <b-row>
          <b-col cols="7">&nbsp;</b-col>
          <b-col cols="5"><small><i>Entspricht einem +{{ weiterbildungProzent.toFixed(2) }}% Faktor vom produktiven Brutto-Stundensatz</i></small></b-col>
        </b-row>
        <b-row>
          <b-col cols="7">Damit steigt der Stundensatz auf :</b-col>
          <b-col cols="5"><b>{{ (stundensatzProduktiv * (100 + arbeitsplatzProzent + weiterbildungProzent) / 100).toFixed(2) }} €/h</b></b-col>
        </b-row>
      </p>
      <hr>
      <p>
        Nun benötigen wir nicht nur Personen die direkt produktiv Arbeiten, bzw. als alleine Tätige nur Stunden
        die in produktive Tätigkeiten und Projekte fließen, sondern es braucht auch Stunden bzw. Leute, um die
        nötigen Koordinations- und Verwaltungsaufgaben vorzunehmen (Buchhaltung &amp; Controlling, Office Management,
        Projektkoordination und -leitung, etc). Hier müssen wir also für eine bestimmte Anzahl an Personen (bzw. Stunden),
        für die wir direkt verrechnen, auch immer eine Overheadperson (bzw. -stunde) einrechnen.
      </p>
      <p>
        <b-row>
          <b-col cols="7">Für wie viele Personen/Stunden wird eine Overhead-Person/-Stunde benötigt:</b-col>
          <b-col cols="2"><b-form-input v-model="overhead" type="number"></b-form-input></b-col>
          <b-col cols="3">Personen/Stunden</b-col>
        </b-row>
        <b-row>
          <b-col cols="7">&nbsp;</b-col>
          <b-col cols="5"><small><i>Entspricht einem +{{ overheadProzent.toFixed(2) }}% Faktor</i></small></b-col>
        </b-row>
        <b-row>
          <b-col cols="7">Der Stundensatz mit Overhead steigt auf :</b-col>
          <b-col cols="5"><b>{{ stundensatzMitOverhead.toFixed(2) }} €/h</b></b-col>
        </b-row>
      </p>
      <p>
        Nun haben wir bereits die Kosten für sämtliches Personal (bzw. alle Tätigkeiten eine*r Selbsständigen)
        eingerechnet. Nun fehlen nur noch die Betriebskosten, die wir nun grob in einem prozentuellen Wert
        abschätzen können. Darin fallen alle Betriebsmittel, die wir für unseren Betrieb noch benötigen,
        die durch Personal und Arbeitsplätze noch nicht abgedeckt sind. Also z.B. Werkststätten- und
        Meetingräume, allfällige weiter Infrastrukturkosten, etc. einzubeziehen.
      </p>
      <p>
        <b-row>
          <b-col cols="7">Restliche Betriebskosten:</b-col>
          <b-col cols="2"><b-form-input v-model="betriebskosten" type="number"></b-form-input></b-col>
          <b-col cols="3">%</b-col>
        </b-row>
        <b-row>
          <b-col cols="7">Der Stundensatz mit Betriebskosten steigt auf :</b-col>
          <b-col cols="5"><b>{{ stundensatzMitBetriebskosten.toFixed(2) }} €/h</b></b-col>
        </b-row>
      </p>
      <p>
        Jetzt hätten wir schon den Stundensatz, den wir für eine Leistungsstunde verrechnen
        können, wenn wir davon ausgehen, dass wir permanent zu 100% ausgelastet sind. Das
        wäre aber weder schlau, noch nachhaltig. In der Praxis müssen wir also am Ende noch
        einen Auslastungsfaktor einrechen, der angibt wie viel der theoretisch verrechenbaren
        Stunden tatsächlich verrechnet werden können. Und damit müssen dennoch die gesamten
        Kosten des Betriebs gedeckt werden. Daher wird dieser Faktor am Ende noch aufgerechnet.
      </p>
      <p>
        <b-row>
          <b-col cols="7">Auslastungsfaktor:</b-col>
          <b-col cols="2"><b-form-input v-model="auslastung" type="number"></b-form-input></b-col>
          <b-col cols="3">%</b-col>
        </b-row>
      </p>

      <br>
      <p align="center">
        <b-alert show variant="success">
          Der <b>finale Stundensatz</b> beträgt damit : &nbsp;&nbsp;&nbsp;&nbsp;
          <b>{{ stundensatzMitAuslastung.toFixed(2) }} €/h</b>
          <!--<b-badge pill variant="warning"><b>{{ stundensatzMitAuslastung.toFixed(2) }} €/h</b></b-badge>-->
        </b-alert>
      </p>
      <br>

      <hr>
      <h1>TODO:</h1>
      <ul>
        <li>Nette Boxen für weiterführende Literatur, Links und Erklärungen</li>
        <li>Footer &amp; gitlab repo</li>
        <li>Umschalter für light &amp; dark theme einbauen</li>
        <li>Grid auch für mobile view (xs &amp; sm) optimieren</li>
        <li>Angabe der Parameter über URI (GET) ermöglichen (und Share Button dazu)</li>
      </ul>

    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Calc',
  data () {
    return {
      wochenstunden: 20,
      monatsnettolohn: 1238,
      sv: 25,
      steuer: 15,
      reprostunden: 1,
      arbeitstage: 248,
      urlaubstage: 25,
      krankenstandstage: 13,
      pflegetage: 13,
      arbeitsplatz: 250,
      weiterbildung: 100,
      overhead: 5,
      betriebskosten: 10,
      auslastung: 80
    }
  },
  computed: {
    jahresbrutto: function () {
      var jahresnetto = this.monatsnettolohn * 12
      var mitSteuer = jahresnetto * 100 / (100 - this.steuer)
      var mitSV = mitSteuer * 100 / (100 - this.sv)
      return mitSV
    },
    nettosatz: function () {
      return this.monatsnettolohn / 4.33 / this.wochenstunden
    },
    bruttosatz: function () {
      return this.monatsnettolohn / 4.33 / this.wochenstunden * 100 / (100 - this.steuer) * 100 / (100 - this.sv)
    },
    stundensatzMitReprostunden: function () {
      return this.bruttosatz * (1 + parseFloat(this.reprostunden))
    },
    arbeitstageNetto: function () {
      return this.arbeitstage - this.urlaubstage - this.krankenstandstage - this.pflegetage
    },
    arbeitstageNettoProzent: function () {
      return this.arbeitstageNetto / this.arbeitstage * 100
    },
    arbeitstageBruttoProzent: function () {
      return (this.arbeitstage / this.arbeitstageNetto - 1) * 100
    },
    stundensatzProduktiv: function () {
      return this.stundensatzMitReprostunden * (this.arbeitstage / this.arbeitstageNetto)
    },
    nettostunden: function () {
      return this.wochenstunden / ((1 + parseFloat(this.reprostunden)) * this.arbeitstage / this.arbeitstageNetto)
    },
    arbeitsplatzProzent: function () {
      return this.arbeitsplatz / (this.nettostunden * 4.33) / this.stundensatzProduktiv * 100
    },
    weiterbildungProzent: function () {
      return this.weiterbildung / (this.nettostunden * 4.33) / this.stundensatzProduktiv * 100
    },
    overheadProzent: function () {
      return ((parseFloat(this.overhead) + 1) / parseFloat(this.overhead) - 1) * 100
    },
    stundensatzMitOverhead: function () {
      return (this.stundensatzProduktiv * (100 + this.arbeitsplatzProzent + this.weiterbildungProzent) / 100) * (parseFloat(this.overhead) + 1) / parseFloat(this.overhead)
    },
    stundensatzMitBetriebskosten: function () {
      return this.stundensatzMitOverhead * (100 + parseInt(this.betriebskosten)) / 100
    },
    stundensatzMitAuslastung: function () {
      return this.stundensatzMitBetriebskosten * (100 / this.auslastung)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Calc.vue